import type { SgmOpportunity } from '@ps/web-sports-api-types';
import React from 'react';

import { SgmOpportunityDescription } from '@swf/layouts/SportsLayout/components/BetSlip/components/SgmOpportunityDescription/SgmOpportunityDescription';

interface Props {
  receiptItem: SgmOpportunity;
}
const SgmReceiptItem: React.FC<Props> = ({ receiptItem }) => {
  if (!receiptItem.sgmData.length) {
    return null;
  }

  return <SgmOpportunityDescription sgmData={receiptItem.sgmData} showDates />;
};

export default SgmReceiptItem;
